module.exports = __webpack_public_path__ + "img/transfer7.96db4bff.jpeg";